import { render } from "./FactureFournisseurPage.vue?vue&type=template&id=d49037d2&scoped=true&ts=true"
import script from "./FactureFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./FactureFournisseurPage.vue?vue&type=script&lang=ts"

import "./FactureFournisseurPage.vue?vue&type=style&index=0&id=d49037d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d49037d2"]])

export default __exports__